import React from 'react';
import { getClassificationBadge } from '../../utils/accountClassificationCatalog';

const COLOR_CLASSES = {
  neutral: 'bg-stone-100 text-stone-700',
  cyan: 'bg-cyan-100 text-cyan-800',
  green: 'bg-emerald-100 text-emerald-800',
  purple: 'bg-violet-100 text-violet-800',
  slate: 'bg-slate-100 text-slate-700',
};

/**
 * Canonical agency classification badge.
 * Prefers backend `classification.{label,color}`; never invents Credit Repair.
 */
export default function AgencyClassificationBadge({
  agency,
  agencyType,
  classification,
  className = '',
  testId,
}) {
  const badge =
    (classification?.label && classification)
    || getClassificationBadge(
      agency
      || (agencyType ? { agency_type: agencyType, classification } : null)
    );

  if (!badge?.label) {
    return (
      <span
        className={`inline-flex px-2 py-0.5 rounded-full text-[11px] font-semibold bg-slate-50 text-slate-400 ${className}`}
        data-testid={testId}
      >
        Not configured
      </span>
    );
  }

  const colorClass = COLOR_CLASSES[badge.color] || COLOR_CLASSES.neutral;
  return (
    <span
      className={`inline-flex px-2 py-0.5 rounded-full text-[11px] font-semibold ${colorClass} ${className}`}
      data-testid={testId}
    >
      {badge.label}
    </span>
  );
}
